import { transformTimelogsToEvents } from './events';

// Combines the two initial loads (Promise.allSettled results), so a failed Projects
// load (for example a Zoho read lock) still shows the People logs, and the other way
// round. `failed` tells the caller to show the error modal for the part that is missing.
export function combineBootstrapResults(projectsResult, peopleResult, peopleLogToEvent) {
  const projectEvents = projectsResult.status === 'fulfilled'
    ? transformTimelogsToEvents({
        timelogs: { date: projectsResult.value?.data?.flatMap(group => group.timelogs || []) || [] },
      })
    : [];
  const peopleEvents = peopleResult.status === 'fulfilled'
    ? (peopleResult.value?.data?.flatMap(group => group.timelogs || []) || []).map(peopleLogToEvent)
    : [];
  return {
    events: [...projectEvents, ...peopleEvents],
    failed: projectsResult.status === 'rejected' || peopleResult.status === 'rejected',
  };
}
